<app-header></app-header>
<ion-content>
  <div id="desktop" *ngIf="this.isNotTouchExperience$ | async">
    <div class="top-section-background">
      <ion-grid [fixed]="true">
        <ion-row>
          <ion-col>
            <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <div class="header-section">
              <h1 data-cy="my-orders-view-title-text">
                {{'i18n.orderStatusPage.myOrders' | translate}}
              </h1>
              <div class="my-orders-toggle" *ngIf="isNotSuperUser$ | async">
                <ion-button
                  class="active-view-button"
                  data-cy="my-orders-view-page-button"
                >
                  <ion-label>
                    {{'i18n.orderStatusPage.myOrders' | translate}}
                  </ion-label>
                </ion-button>

                <ion-button
                  class="inactive-view-button"
                  (click)="routeTo('my-orders')"
                  data-cy="order-status-page-button"
                >
                  <ion-label>
                    {{'i18n.orderStatusPage.orderStatus' | translate}}
                  </ion-label>
                </ion-button>
              </div>
            </div>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="swiper-button-container">
            <ion-button
              fill="blank"
              class="swiper-buttons"
              [ngClass]="activeTab === 'current' ? 'swiper-buttons-active' : ''"
              (click)="switchTab('past')"
            >
              {{'i18n.orderStatusPage.currentOrders' | translate}}
            </ion-button>
            <ion-button
              fill="blank"
              class="swiper-buttons"
              [ngClass]="activeTab === 'past' ? 'swiper-buttons-active' : ''"
              (click)="switchTab('current')"
            >
              {{'i18n.orderStatusPage.pastOrders' | translate}}
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>

    <div class="bottom-section-background">
      <!-- DESKTOP - VIEWPORT FOR CURRENT ORDERS -->
      <cdk-virtual-scroll-viewport
        *ngIf="this.activeTab === 'current'"
        class="cdk-scroll-desktop-my-orders"
        orientation="vertical"
        itemSize="87"
        minBufferPx="1000"
        maxBufferPx="2000"
      >
        <div class="swiper-container">
          <ion-grid [fixed]="true">
            <div
              class="no-orders"
              *ngIf="!!myOrders?.myOrdersRows && myOrders?.myOrdersRows.length === 0"
              data-cy="my-orders-view-no-order-text"
            >
              {{'i18n.orderStatusPage.noOrdersMsg' | translate}}
            </div>

            <app-my-orders-list-view
              *ngIf="this.activeTab === 'current'"
              [ordersList]="myOrders"
              [pastOrders]="false"
            ></app-my-orders-list-view>

            <ng-container
              *ngIf="myOrders?.orderCounts?.openOrdersCount < 1"
              [ngTemplateOutlet]="noOpenOrders"
            ></ng-container>
          </ion-grid>
          <div class="footer-wrapper">
            <app-footer></app-footer>
          </div>
        </div>
      </cdk-virtual-scroll-viewport>

      <!-- DESKTOP - VIEWPORT FOR PAST ORDERS -->
      <cdk-virtual-scroll-viewport
        *ngIf="this.activeTab === 'past'"
        class="cdk-scroll-desktop-my-orders"
        orientation="vertical"
        itemSize="87"
        minBufferPx="1000"
        maxBufferPx="2000"
      >
        <div class="swiper-container">
          <ion-grid [fixed]="true">
            <div
              class="no-orders"
              *ngIf="!myOrders?.pastOrdersRows?.length"
              data-cy="my-orders-view-no-order-text"
            >
              {{'i18n.orderStatusPage.noOrdersMsg' | translate}}
            </div>

            <app-my-orders-list-view
              [customerOrdersList]="myOrders"
              [pastOrders]="true"
              (quickViewClickEmitter)="openCopyOrderModal($event.pastOrderRow)"
            ></app-my-orders-list-view>
            <ng-container
              *ngIf="myOrders?.orderCounts?.openOrdersCount < 1"
              [ngTemplateOutlet]="noOpenOrders"
            ></ng-container>
          </ion-grid>
          <div class="footer-wrapper">
            <app-footer></app-footer>
          </div>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>

  <!-- TOUCH EXPERIENCE -->
  <ng-container *ngIf="this.isTouchExperience$ | async">
    <ng-container *ngIf="hideRefresher === false">
      <ion-refresher
        *appShowSplit="[myOrdersRefresherFlag]"
        slot="fixed"
        [pullFactor]="1"
        [pullMin]="50"
        [pullMax]="900"
        (ionRefresh)="handleRefresh($event)"
      >
        <ion-refresher-content
          pullingIcon="chevron-down"
          pullingText=""
          refreshingSpinner="circles"
          refreshingText=""
        >
        </ion-refresher-content>
      </ion-refresher>
    </ng-container>
    <ng-container *ngIf="isTablet$ | async">
      <!-- TABLET -->
      <div class="tablet-container">
        <div class="bottom-section-background-touch">
          <!-- TABLET - VIEWPORT FOR CURRENT ORDERS -->
          <cdk-virtual-scroll-viewport
            *ngIf="!pastOrders"
            orientation="vertical"
            itemSize="140"
            minBufferPx="300"
            maxBufferPx="900"
          >
            <div class="header-section">
              <h1 data-cy="my-orders-view-title-text">
                {{'i18n.orderStatusPage.myOrders' | translate}}
              </h1>

              <div class="my-orders-toggle" *ngIf="isNotSuperUser$ | async">
                <ion-button
                  class="active-view-button"
                  data-cy="my-orders-view-page-button"
                >
                  <ion-label>
                    {{'i18n.orderStatusPage.myOrders' | translate}}
                  </ion-label>
                </ion-button>

                <ion-button
                  class="inactive-view-button"
                  (click)="routeTo('my-orders')"
                  data-cy="order-status-page-button"
                >
                  <ion-label>
                    {{'i18n.orderStatusPage.orderStatus' | translate}}
                  </ion-label>
                </ion-button>
              </div>
            </div>
            <ion-row>
              <div class="swiper-button-wrapper">
                <ion-col
                  class="swiper-button-container"
                  [ngClass]="tabAnimate === true ? 'add-bounce' : ''"
                >
                  <ion-button
                    fill="blank"
                    class="swiper-buttons swiper-buttons-active"
                  >
                    {{'i18n.orderStatusPage.currentOrders' | translate}}
                  </ion-button>
                  <ion-button
                    fill="blank"
                    class="swiper-buttons swiper-buttons-not-active"
                    (click)="switchTabTouchView()"
                  >
                    {{'i18n.orderStatusPage.pastOrders' | translate}}
                  </ion-button>
                </ion-col>
              </div>
            </ion-row>
            <div
              class="no-orders"
              *ngIf="!!myOrders?.myOrdersRows && myOrders?.myOrdersRows.length === 0"
              data-cy="no-orders-message"
            >
              {{'i18n.orderStatusPage.noOrdersMsg' | translate}}
            </div>
            <app-my-orders-list-view-tablet
              [ordersList]="myOrders"
              [pastOrders]="false"
            ></app-my-orders-list-view-tablet>
            <ng-container
              *ngIf="myOrders?.orderCounts?.openOrdersCount < 1"
              [ngTemplateOutlet]="noOpenOrders"
            ></ng-container>
          </cdk-virtual-scroll-viewport>
          <!-- TABLET - VIEWPORT FOR PAST ORDERS -->
          <cdk-virtual-scroll-viewport
            *ngIf="pastOrders"
            orientation="vertical"
            itemSize="140"
            minBufferPx="300"
            maxBufferPx="900"
          >
            <div class="header-section">
              <h1 data-cy="my-orders-view-title-text">
                {{'i18n.orderStatusPage.myOrders' | translate}}
              </h1>

              <div class="my-orders-toggle" *ngIf="isNotSuperUser$ | async">
                <ion-button
                  class="active-view-button"
                  data-cy="my-orders-view-page-button"
                >
                  <ion-label>
                    {{'i18n.orderStatusPage.myOrders' | translate}}
                  </ion-label>
                </ion-button>

                <ion-button
                  class="inactive-view-button"
                  (click)="routeTo('my-orders')"
                  data-cy="order-status-page-button"
                >
                  <ion-label>
                    {{'i18n.orderStatusPage.orderStatus' | translate}}
                  </ion-label>
                </ion-button>
              </div>
            </div>
            <ion-row>
              <div class="swiper-button-wrapper">
                <ion-col
                  class="swiper-button-container"
                  [ngClass]="tabAnimate === true ? 'add-bounce' : ''"
                >
                  <ion-button
                    fill="blank"
                    class="swiper-buttons swiper-buttons-not-active"
                    (click)="switchTabTouchView()"
                  >
                    {{'i18n.orderStatusPage.currentOrders' | translate}}
                  </ion-button>
                  <ion-button
                    fill="blank"
                    class="swiper-buttons swiper-buttons-active"
                    (click)="switchTabTouchView()"
                  >
                    {{'i18n.orderStatusPage.pastOrders' | translate}}
                  </ion-button>
                </ion-col>
              </div>
            </ion-row>
            <div
              class="no-orders"
              *ngIf="myOrders?.pastOrdersRows?.length === 0"
              data-cy="no-orders-message"
            >
              {{'i18n.orderStatusPage.noOrdersMsg' | translate}}
            </div>
            <app-my-orders-list-view-tablet
              [customerOrdersList]="myOrders"
              [pastOrders]="true"
              (quickViewClickEmitter)="openCopyOrderModal($event.pastOrderRow)"
            ></app-my-orders-list-view-tablet>
            <ng-container
              *ngIf="myOrders?.orderCounts?.openOrdersCount < 1"
              [ngTemplateOutlet]="noOpenOrders"
            ></ng-container>
          </cdk-virtual-scroll-viewport>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="isMobile$ | async">
      <!-- MOBILE -->
      <div class="mobile-container">
        <div class="bottom-section-background-touch">
          <!-- MOBILE - VIEWPORT FOR CURRENT ORDERS -->
          <cdk-virtual-scroll-viewport
            *ngIf="!pastOrders"
            class="mobile-cdk-viewport"
            orientation="vertical"
            itemSize="170"
            minBufferPx="400"
            maxBufferPx="1000"
          >
            <ion-row>
              <ion-col>
                <div class="mobile-header">
                  <div class="my-orders-toggle" *ngIf="isNotSuperUser$ | async">
                    <ion-button
                      class="active-view-button"
                      data-cy="my-orders-view-page-button"
                    >
                      <ion-label>
                        {{'i18n.orderStatusPage.myOrders' | translate}}
                      </ion-label>
                    </ion-button>

                    <ion-button
                      class="inactive-view-button"
                      (click)="routeTo('my-orders')"
                      data-cy="order-status-page-button"
                    >
                      <ion-label>
                        {{'i18n.orderStatusPage.orderStatus' | translate}}
                      </ion-label>
                    </ion-button>
                  </div>
                </div>
              </ion-col>
            </ion-row>
            <ion-row>
              <div class="swiper-button-wrapper">
                <ion-col
                  class="swiper-button-container"
                  [ngClass]="tabAnimate === true ? 'add-bounce' : ''"
                >
                  <ion-button
                    fill="blank"
                    class="swiper-buttons swiper-buttons-active"
                  >
                    {{'i18n.orderStatusPage.currentOrders' | translate}}
                  </ion-button>
                  <ion-button
                    fill="blank"
                    class="swiper-buttons swiper-buttons-not-active"
                    (click)="switchTabTouchView()"
                  >
                    {{'i18n.orderStatusPage.pastOrders' | translate}}
                  </ion-button>
                </ion-col>
              </div>
            </ion-row>
            <div
              class="no-orders"
              *ngIf="!!myOrders?.myOrdersRows && myOrders?.myOrdersRows.length === 0"
              data-cy="no-orders-message"
            >
              {{'i18n.orderStatusPage.noOrdersMsg' | translate}}
            </div>
            <app-my-orders-list-view-mobile
              [ordersList]="myOrders"
              [pastOrders]="false"
            >
            </app-my-orders-list-view-mobile>
            <ng-container
              *ngIf="myOrders?.orderCounts?.openOrdersCount < 1"
              [ngTemplateOutlet]="noOpenOrders"
            ></ng-container>
          </cdk-virtual-scroll-viewport>

          <!-- MOBILE - VIEWPORT FOR PAST ORDERS -->
          <cdk-virtual-scroll-viewport
            *ngIf="pastOrders"
            class="mobile-cdk-viewport"
            orientation="vertical"
            itemSize="170"
            minBufferPx="400"
            maxBufferPx="1000"
          >
            <ion-row>
              <ion-col>
                <div class="mobile-header">
                  <div class="my-orders-toggle" *ngIf="isNotSuperUser$ | async">
                    <ion-button
                      class="active-view-button"
                      data-cy="my-orders-view-page-button"
                    >
                      <ion-label>
                        {{'i18n.orderStatusPage.myOrders' | translate}}
                      </ion-label>
                    </ion-button>

                    <ion-button
                      class="inactive-view-button"
                      (click)="routeTo('my-orders')"
                      data-cy="order-status-page-button"
                    >
                      <ion-label>
                        {{'i18n.orderStatusPage.orderStatus' | translate}}
                      </ion-label>
                    </ion-button>
                  </div>
                </div>
              </ion-col>
            </ion-row>
            <ion-row>
              <div class="swiper-button-wrapper">
                <ion-col
                  class="swiper-button-container"
                  [ngClass]="tabAnimate === true ? 'add-bounce' : ''"
                >
                  <ion-button
                    fill="blank"
                    class="swiper-buttons swiper-buttons-not-active"
                    (click)="switchTabTouchView()"
                  >
                    {{'i18n.orderStatusPage.currentOrders' | translate}}
                  </ion-button>
                  <ion-button
                    fill="blank"
                    class="swiper-buttons swiper-buttons-active"
                  >
                    {{'i18n.orderStatusPage.pastOrders' | translate}}
                  </ion-button>
                </ion-col>
              </div>
            </ion-row>
            <div
              class="no-orders"
              *ngIf="!myOrders?.pastOrdersRows?.length"
              data-cy="no-orders-message"
            >
              {{'i18n.orderStatusPage.noOrdersMsg' | translate}}
            </div>
            <app-my-orders-list-view-mobile
              [customerOrdersList]="myOrders"
              [pastOrders]="true"
              (quickViewClickEmitter)="openCopyOrderModal($event.pastOrderRow)"
            >
            </app-my-orders-list-view-mobile>
          </cdk-virtual-scroll-viewport>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ion-content>

<div class="create-button-wrapper" *ngIf="this.isTouchExperience$ | async">
  <ion-button
    id="create-new-order-btn"
    class="usf-outline-green-mobile-modal-button"
    data-cy="create-new-order-button"
    (click)="createNewOrder()"
  >
    {{'i18n.orderStatusPage.createNewOrderButton' | translate}}
  </ion-button>
</div>

<!-- FLOATING TOOLTIP -->
<div class="help-icon">
  <img
    data-cy="my-orders-page-open-help-modal-button"
    src="assets/icon/custom-help-tooltip.svg"
    (click)="openHelpModal()"
  />
</div>

<div data-cy="my-orders-top-button-section" class="top-button">
  <ion-button
    data-cy="my-orders-top-button"
    class="usf-fill-green-button top-button-adjust"
    (click)="goToTop()"
  >
    {{ 'i18n.common.top' | translate }}&nbsp;
    <ion-icon data-cy="my-orders-top-button-icon" name="chevron-up"></ion-icon>
  </ion-button>
</div>

<!-- NO ORDER VIEW TEMPLATES -->
<ng-template #noOpenOrders>
  <div class="no-order-container">
    <img
      src="assets/images/box-dimension-black.svg"
      class="box-dimension-image"
      alt="box-image"
    />
    <p data-cy="no-open-orders-message">
      {{'i18n.orderStatusPage.noOpenOrdersMessage' | translate}}
      {{myOrders?.selectedCustomer?.customerName || ''}}.
    </p>
    <ion-button
      class="usf-fill-green-button"
      (click)="createNewOrder()"
      data-cy="create-new-order-button"
      >{{'i18n.orderStatusPage.createNewOrderButton' | translate}}</ion-button
    >
  </div>
</ng-template>

<ng-template #noSubmittedOrders>
  <div class="no-order-container">
    <img
      src="assets/images/box-dimension-black.svg"
      class="box-dimension-image"
      alt="box-image"
    />
    <p data-cy="no-submitted-orders-message">
      {{'i18n.orderStatusPage.noOpenOrdersMessage' | translate}}
      {{myOrders?.selectedCustomer?.customerName || ''}}.
    </p>
  </div>
</ng-template>
